import { useHouseContext } from '@/context/HouseContext';
import { useAuth } from '@/context/AuthContext';
import { hasAdminRoleInProperty, hasContributorRole, hasOwnerRole, hasViewerRoleInProperty } from '@/utils/roleUtils';
import { isFullyRegisteredAccount, isStandardAccount } from '@/utils/userUtils.ts';

export const DEFAULT_STATE = {
	isStandard: false,
	is: false,
	isOwner: false,
	isAdmin: false,
	isContributor: false,
	isCreator: false,
	isViewer: false,
	isOwnerOrAdmin: false,
	hasSelectedHouse: false,
	showMyBundlesLink: true,
	canAddNewProperties: false,
};
/**
 * Hook for getting property-specific roles without requiring CurrentHouseProvider
 * Works with HouseContext which is available at the PageLayout level
 *
 * This is a lightweight alternative to useCurrentHouse() for components
 * that only need role information without the full house context overhead
 */
export const usePropertyRoles = () => {
	const { selectedHouse } = useHouseContext();
	const { user } = useAuth();

	if (!selectedHouse || !user) {
		return DEFAULT_STATE;
	}

	const showMyBundlesLink = true;

	const isOwner = hasOwnerRole(selectedHouse, user);
	const isAdmin = hasAdminRoleInProperty(selectedHouse, user);

	return {
		canAddNewProperties: isFullyRegisteredAccount(user),
		isStandardAccount: isStandardAccount(user),
		isViewer: hasViewerRoleInProperty(selectedHouse, user),
		isContributor: hasContributorRole(selectedHouse, user),
		// Original creator of the property record (e.g. the professional who set it up) — distinct from
		// the current owner, who may have received it via transfer.
		isCreator: selectedHouse.created_by_id === user.id,
		isAdmin,
		isOwner,
		isOwnerOrAdmin: isOwner || isAdmin,
		hasSelectedHouse: true,
		showMyBundlesLink,
	};
};
